/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC, useEffect, useState} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {Logout} from '../modules/auth'
import {AuthPage, useAuth} from '../modules/auth'
import {App} from '../App'
import api from '../../services/apiConfig'
import {IUsuairo} from '../../types/Usuarios'
import {useMsal} from '@azure/msal-react'
import {InteractionStatus} from '@azure/msal-browser'
//import { authContext } from '../../configs/adal.config'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */

const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  const {currentUser} = useAuth()
  
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/500' element={currentUser ? <Navigate to='/' replace /> : <ErrorsPage />} />

          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />

          {currentUser ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/dashboard' replace />} />
            </>
          ) : (
            <Route path='*' element={<Navigate to='/error/500' replace />} />
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
